var menu_module = require('../modules_m/menu_module/menu_module.js');

var url_util = require('../../url_util/url_util.js');
var location_object = url_util.getLocation();

menu_module.init($.ajax({
	url: '/json/module/ModuleApi/getNavList.json',
	type: 'GET',
	dataType: 'json',
	data: {
		isPreviewMode: location_object.search.get('edit')
	}
}).then(function (data) {
	data.item.navList && (data.item.navList.submenuInfo = data.item.submenuInfo);
	return data.item.navList;
})).then(function ($dom) {
	$dom.appendTo('body');
});


//////////////////
// WEBPACK FOOTER
// ./~/@souche-f2e/chunyan-util/qiwa-common_m/lib/menu_module.js
// module id = 277
// module chunks = 4